import React from "react";
import ProjectDetails from '../../components/ProjectDetails';

const individualServices = () => {
  return (
    <>
      {/* Banner Section  */}
      <section>
        <ProjectDetails />
      </section>
    </>
  );
};

export default individualServices;